export default "__VITE_ASSET__c74e2b7c__"